import React, { useContext } from 'react';
import classnames from 'classnames';
import TextualContent from '../../TextualContent';
import { useDeviationViewContext } from '../../../Context';
import AutoSizedText from '../_partials/AutoSizedText';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { getDeviationTitle } from '../../_helpers';
import s from './Tier.scss';
var TierFullView = function (_a) {
    var deviation = _a.deviation, width = _a.width, height = _a.height;
    var isMobile = useContext(MobileContext);
    var _b = useDeviationViewContext(), isFullscreen = _b.isFullscreen, isTheater = _b.isTheater;
    var style = isTheater || isFullscreen || isMobile ? { width: width, height: height } : { width: width };
    return (React.createElement("div", { className: classnames(s['root'], isFullscreen && s['fullscreen']), style: style },
        React.createElement("div", { className: s['content-wrap'] },
            React.createElement("div", { className: s['title-wrap'] },
                React.createElement(AutoSizedText, { className: s['title'], tooBigClassName: s['better-fit'], maxHeight: 180 }, getDeviationTitle(deviation))),
            isFullscreen && (React.createElement(TextualContent, { deviation: deviation, withArtist: false })))));
};
TierFullView.displayName = 'TierFullView';
export default TierFullView;
//# sourceMappingURL=Tier.js.map